<template>
  <validation-observer v-slot="{ invalid, errors }">
    <div class="passengers-info">
      <passenger-form
        v-for="(passenger, passenger_index) in passengers"
        :key="`pax_${passenger_index}`"
        :passenger="passenger"
        :passenger_index="passenger_index"
      />

      <slot name="footer" :invalid="invalid" :errors="errors" />
    </div>
  </validation-observer>
</template>

<script>
import PassengerForm from "./passenger-form.vue";

export default {
  name: "passengers-info",
  components: {
    "passenger-form": PassengerForm,
  },
  props: {
    passengers: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.passengers-info {
  display: flex;
  flex-direction: column;
  gap: $grid-gutter-width;
  margin-top: $grid-gutter-width;
  margin-bottom: $grid-gutter-width;
}
</style>
